import { SearchInput, AdvancedCombobox, Button, Icon, ButtonTooltip } from '@evertrue/et-components';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import DateRangeFilter from './video-library-date-picker';
import { useSignalVideoModalContext } from 'apps/signal-video/contexts/use-signal-video-modal-context';

const sortTypes = [
  { label: 'Date Created', value: 'created_at', defaultOrder: 'desc' },
  { label: 'Date Modified', value: 'updated_at', defaultOrder: 'desc' },
  { label: 'Title', value: 'name', defaultOrder: 'asc' },
  { label: 'Duration', value: 'video_length', defaultOrder: 'asc' },
];

const ControlTools = ({
  searchText,
  setSearchText,
  sortSelected,
  setSortSelected,
  isAscOrder,
  setIsAscOrder,
  onDateRangeChange,
  totalCount,
}) => {
  const { handleChangeModalView } = useSignalVideoModalContext();
  return (
    <div className="video-library--control-tools">
      <div className="video-library--top-row">
        <SearchInput
          value={searchText}
          onChange={setSearchText}
          width={350}
          placeholder="Search for a Video"
          debounceTimeout={300}
        />
        <div className="video-count">{totalCount} Videos</div>
        <ButtonTooltip
          trigger={
            <Icon icon="settings" onClick={() => handleChangeModalView('settings')} className="settings-icon"></Icon>
          }
        >
          <div>Edit Default Settings</div>
        </ButtonTooltip>
      </div>
      <div className="video-library--bottom-row">
        <p>Sort By:</p>
        <Button
          className={classNames('order-button', { 'is-asc': isAscOrder })}
          onClick={() => setIsAscOrder(!isAscOrder)}
          label="order of videos"
          type="simple"
        >
          <Icon icon="arrow-down" iconKit="gt" />
        </Button>
        <span style={{ margin: '0 8px' }}>
          <AdvancedCombobox onChange={setSortSelected} value={sortSelected} options={sortTypes} />
        </span>
        <p>Date Range:</p>
        <DateRangeFilter onDateRangeChange={onDateRangeChange} />
      </div>
    </div>
  );
};

ControlTools.propTypes = {
  searchText: PropTypes.string.isRequired,
  setSearchText: PropTypes.func.isRequired,
  sortSelected: PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    defaultOrder: PropTypes.string.isRequired,
  }).isRequired,
  totalCount: PropTypes.number,
  setSortSelected: PropTypes.func.isRequired,
  isAscOrder: PropTypes.bool.isRequired,
  setIsAscOrder: PropTypes.func.isRequired,
  onDateRangeChange: PropTypes.func.isRequired,
};

export default ControlTools;
